import { http } from "../client";
export var deleteTimetableRuleset = function (id) {
    return http.api.delete("timetable-programs/".concat(id));
};
